import React from 'react';

const ContactSupportButton = () => {
  return (
    <div className={'text-center text-sm leading-[19px]'}>
      <a
        href={'https://geniebook.com/contact'}
        className={
          'text-primary-apricot font-bold underline cursor-pointer leading-[1.2]'
        }
        target={'_blank'}
        rel="noreferrer"
      >
        Contact support
      </a>
      <div className={'text-neutral-pencil'}>to reactivate your hints plan</div>
    </div>
  );
};

export default ContactSupportButton;
